import { PULSEPOINT_ADMIN_AGENCY } from './constants'
import { CognitoUserSession } from 'amazon-cognito-identity-js'

export const isPulsePointSuperUser = (session?: CognitoUserSession) => {
  if (
    session &&
    session.getIdToken() &&
    session.getIdToken().payload['permissions'] &&
    session?.getIdToken().payload['permissions'] != '0'
  ) {
    return PULSEPOINT_ADMIN_AGENCY in JSON.parse(session?.getIdToken().payload['permissions'])
  }
  return false
}

export const isIncidentAdminForAgency = (session?: CognitoUserSession, agencyID?: string) => {
  return hasPermissionForAgency(session, 'INCIDENTADMIN', agencyID)
}

export const hasPermissionForAgency = (session?: CognitoUserSession, permissionKey?: string, agencyID?: string) => {
  if (!permissionKey) {
    return false
  }
  let superuserPermissions = permissionsForAgency(session, PULSEPOINT_ADMIN_AGENCY)
  let agencyPermissions = permissionsForAgency(session, agencyID)
  return superuserPermissions[permissionKey] !== undefined || agencyPermissions[permissionKey] !== undefined
}

export const permissionsForAgency = (session?: CognitoUserSession, agencyID?: string) => {
  if (!session || !agencyID) {
    return {}
  }

  try {
    let permissions = JSON.parse(session.getIdToken().payload['permissions'])
    return permissions[agencyID] ?? {}
  } catch (error) {
    return {}
  }
}
